'use client'

import React from 'react'
import { Box, Container } from '@mui/material'

import MobileAppPromotionWrapper from '../mobileAppPromotion'
import TrendingSearchesWrapper from '../../trendingSearches'

interface DesktopPromotionAndSearchesProps {
    isMobile: boolean
}

const DesktopPromotionAndSearches: React.FC<DesktopPromotionAndSearchesProps> = ({ isMobile }) => {
    return (
        <Box
            sx={{
                display: { xs: 'none', md: 'block' },
                bgcolor: 'grey.50',
                py: 4
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        alignItems: 'stretch',
                        width: '100%'
                    }}
                >
                    {/* Left: Mobile App Promotion - Vertical Layout (30%) */}
                    <Box
                        sx={{
                            flex: '0 0 30%',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100%'
                        }}
                    >
                        <MobileAppPromotionWrapper verticalLayout={true} />
                    </Box>

                    {/* Right: Trending Searches (70%) */}
                    <Box
                        sx={{
                            flex: '0 0 70%',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100%'
                        }}
                    >
                        <TrendingSearchesWrapper isMobile={isMobile} />
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default DesktopPromotionAndSearches
